import './layout.css';

import { GOOGLE_CLIENT_ID } from '@features/env';
import { AppThemeColorProvider } from '@features/shared/components/app-theme-color-provider';
import { NewVersionBottomSheet } from '@features/shared/components/new-version-bottom-sheet';
import { CenteredSpinner } from '@features/shared/ui/spinner';
import { Toaster } from '@features/shared/ui/toaster';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      retry: (failureCount) => failureCount < 2,
    },
  },
});

export function Layout() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <AppThemeColorProvider>
          <Suspense fallback={<CenteredSpinner />}>
            <Outlet />
            <Toaster />
          </Suspense>
          <NewVersionBottomSheet />
        </AppThemeColorProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}
